import { ChangeDetectionStrategy, Component, HostBinding, computed, input } from '@angular/core';
import { stringHelper } from 'lib/helpers/string-helper.class.js';

@Component({
    selector: 'lib-avatar-from-name',
    templateUrl: './avatar-from-name.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AvatarFromNameComponent {
	public readonly size = input<40 | 150 | number>(40);
	public readonly name = input.required<string>();
	public readonly isRound = input<boolean>(true);
	public readonly borderRadius = input<number>(0);
	public readonly charCount = input<number>(2);
	public readonly cssStyles = input<Partial<CSSStyleDeclaration>>();

	@HostBinding('style') style = 'display: block';

	public readonly calculatedName = computed<string>(() => {
		// add space after each char because it's used as char
		const name = stringHelper.replaceNonAlphanumericExceptUnderscore(this.name(), '');
		let finalName = '';

		if (!name.length) {
			return 'unknown';
		}

		// always only take the chars that is set in 'charCount' 
		// reason is because "Kara" and "Kara Smith" will give different colors
		// even though both start with "ka"
		for (let i = 0; i < name.length || i < this.charCount(); i++) {
			finalName += ` ${name[i]}`;
		}

		return finalName;
	});
}
